import { Box, Pagination, Skeleton, Stack } from '@mui/material';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { PAGE_SIZE } from 'services/constants/env';
import queryString from 'query-string';

export type TPaginationBlockProps = {
	isLoading: boolean;
	total: number;
};

export const PaginationBlock: FC<TPaginationBlockProps> = ({ isLoading, total }) => {
	const navigate = useNavigate();
	const { search } = useLocation();
	const location = useLocation();
	const navigateParams = queryString.parse(search);
	const currentPage = Number(navigateParams?.page ?? 1);

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		navigate(
			`${location.pathname}?${queryString.stringify({
				...navigateParams,
				page: value ?? 1,
			})}`,
		);
	};

	return (
		<Box sx={{ m: '0 -20px' }}>
			{!isLoading && Math.ceil((total ?? 0) / PAGE_SIZE) > 1 && (
				<Stack spacing={2} marginTop={2}>
					<Pagination
						count={Math.ceil((total ?? 0) / PAGE_SIZE)}
						page={currentPage}
						onChange={handlePageChange}
						shape="rounded"
						color="primary"
						sx={{ '& .MuiPaginationItem-root': { borderRadius: '12px' } }}
					/>
				</Stack>
			)}
			{isLoading && (
				<Skeleton
					variant="rectangular"
					height="40px"
					width="350px"
					sx={{
						mt: 2,

						borderRadius: '12px',
						'& .MuiCardContent-root': { padding: '8px 16px 4px 16px!important' },
					}}
				/>
			)}
		</Box>
	);
};
